import { useMemo, useState } from "react";
import { useUser } from "src/shared/context/UserContext";
import { Order } from "../services/interfacev2";
import { splitDateTime } from "../components/dateTime";

interface OrderDisplayProps {
  bproducts: Order | undefined;
  orderid: string;
  logo: string;
  outstangingamount: number;
  getorder: Order | undefined;
}

export const useOrderDisplay = ({ bproducts, outstangingamount, getorder }: OrderDisplayProps) => {
  const [filteredCustomerId, setFilteredCustomerId] = useState<string>("");
  const [inputValue, setInputValue] = useState<string>("0");
  const [condition, setcondition] = useState<number>(0);
  const [showBalance, setShowBalance] = useState<boolean>(false);
  const [model, setmodel] = useState<boolean>(false);
  const [glowery, setglowery] = useState<boolean>(false);
  const [confirm, setConfirm] = useState<boolean>(false);
  const [printHistory, setPrintHistory] = useState<boolean>(false);
  const [paylate, setpaylate] = useState<boolean>(false);
  const [paycard, setpaycard] = useState<boolean>(false);
  const [cashpay, setcashpay] = useState<boolean>(false);
  const { user } = useUser();

  const Receivedbalance = useMemo(() => {
    if (!getorder?.orders?.length) return 0;

    // const receivedAmount = getorder.orders.reduce((sum, order) => {
    //   return sum + Number(order.receivedAmount || 0) + Number(order.ledgerReceivedAmount || 0);
    // }, 0);
    const receivedAmount = getorder.paymentHistory.reduce((sum, order) => {
      return sum + Number(order.receivedAmount || 0);
    }, 0);

    const finalAmount = getorder.orders.reduce((sum, order) => {
      return sum + Number(order.finalAmount || 0);
    }, 0);

    return Math.min(receivedAmount, finalAmount);
  }, [getorder]);

  const AdvanceAmount = getorder?.orders[0].creditAdjust
  const hasAdvanceAmount = AdvanceAmount !== undefined &&  AdvanceAmount !== null &&  AdvanceAmount !== 0;

  const businessArabicName = user?.orgArabicName || "";
  const businessLocation = user?.businessLocation || "";
  const paid = bproducts?.paymentHistory?.length ? Number(bproducts.paymentHistory.at(-1)?.receivedAmount ?? 0) : 0;
  const unpaid = Number(bproducts?.orders[0].finalAmount) - Receivedbalance - (Number(bproducts?.orders[0]?.ledgerDiscountAmount ?? 0)) - (hasAdvanceAmount ? AdvanceAmount : 0);;
  const prvPaid = bproducts?.paymentHistory?.length && bproducts.paymentHistory.length > 1 && bproducts.paymentHistory[0] ? Number(bproducts.paymentHistory[0]?.receivedAmount ?? 0) : 0;
  const PreviousBalance = (bproducts?.orders[0].finalAmount ?? 0) - (bproducts?.paymentHistory?.length && bproducts.paymentHistory.length > 1 ? (bproducts.paymentHistory[0]?.receivedAmount ?? 0) : 0);
  const products =
    bproducts?.orderDetails?.[0]?.products?.map((p) => ({
      productName: p.name ?? p.name ?? "",
      arabicword: p.arabicName,
      amount: Number(p.unitPrice ?? p.unitPrice ?? 0),
      quantity: Number(p.quantity ?? 0),
      totalPrice: Number(p.lineTotal) || Number(p.unitPrice ?? 0) * Number(p.quantity ?? 0) || 0,
    })) || [];
  const { date: orderDate, time: orderTime } = splitDateTime(bproducts?.orderDetails[0].orderedOn.$date ?? "");
  const CustomerName = [bproducts?.customerDetails?.firstName, bproducts?.customerDetails?.middleName, bproducts?.customerDetails?.lastName].filter(Boolean).join(" ");

  // const discount = useMemo(() => {
  //   if (!getorder?.orders?.length) return 0;
  //   const discountValue = Number(getorder.orders.reduce((sum, order) => {
  //     // return sum + Number(order.discount || 0) + Number(order.ledgerDiscountAmount || 0);
  //     return  Number(order.discount || 0);
  //   }, 0),
  //   );
  //   return discountValue;
  // }, [getorder]);

  // const ledgerDiscount = useMemo(() => {
  //   if (!getorder?.orders?.length) return 0;
  //   const ledgerDiscountAmount = Number(getorder.orders.reduce((sum, order) => {
  //     return Number(order.discount || 0);
  //   }, 0),
  //   );
  //   return ledgerDiscountAmount;
  // }, [getorder]);

  
  const ledgerDiscount = useMemo(() => {
    if (!getorder?.orders?.length) return 0;
    return Number(
      getorder.orders.reduce((sum, order) => {
        return sum + Number(order.ledgerDiscountAmount || 0);
      }, 0),
    );
  }, [getorder]);
  
  const discount = useMemo(() => {
    if (!getorder?.orders?.length) return 0;
    return Number(
      getorder.orders.reduce((sum, order) => {
        return sum + Number(order.discount || 0) + (ledgerDiscount || 0);
      }, 0),
    );
  }, [getorder]);

  const printData = {
    CustomerName: CustomerName,
    CustomerPhon: bproducts?.customerDetails?.phones?.[0].phone || "",
    OrderId: bproducts?.orders[0].orderId,
    OrderStatus: bproducts?.orders[0].status || "",
    Date: orderDate,
    Time: orderTime,
    Products: products,
    Paid: paid,
    // unpaid: Number(bproducts?.orders?.at(-1)?.remainingAmount ?? 0),
    unpaid: unpaid,
    OSB: Number(outstangingamount),
    busnessName: user?.orgName || "",
    busnessArabicName: businessArabicName,
    businessLocation: businessLocation,
    paymentMethod: bproducts?.paymentHistory[0]?.paymentMethod || "",
    phoneNum: user?.phones || "",
    total: bproducts?.orders[0].orderAmount || "",
    clientId: filteredCustomerId,
    billNo: bproducts?.orders?.[bproducts.orders.length - 1]?.billNumber ?? "N/A",
    discount: discount,
    deliveryFee: Number(bproducts?.orders[0].deliveryFee || 0),
    subtotal: Number(getorder?.orders[0].finalAmount),
    prvPaid: prvPaid,
    prvBalance: PreviousBalance,
    prvAvabile: false,
    createdBy: bproducts?.orders?.[bproducts.orders.length - 1]?.createdByName || "N/A",
  };

  const Remainingpayments = useMemo(() => {
    if (!getorder?.orders?.length) return 0;
    return Number(getorder.orders.at(-1)?.receivedAmount || 0);
  }, [getorder]);

  // const Receivedbalance = useMemo(() => {
  //   if (!getorder?.orders?.length) return 0;

  //   const receivedAmount = getorder.orders.reduce((sum, order) => {
  //     return sum + Number(order.receivedAmount || 0) + Number(order.ledgerReceivedAmount || 0);
  //   }, 0);

  //   const finalAmount = getorder.orders.reduce((sum, order) => {
  //     return sum + Number(order.finalAmount || 0);
  //   }, 0);

  //   return Math.min(receivedAmount, finalAmount);
  // }, [getorder]);

  // const remaining = () => {
  //   if (!getorder?.orders?.length) return 0;

  //   const latestOrder = getorder.orders.at(-1);
  //   const balance = Number((Number(latestOrder?.remainingAmount) - Number(latestOrder?.creditAdjust)) || 0);

  //   return balance <= 0 ? 0 : balance;
  // };

 const remaining = () => {
  if (!getorder?.orders?.length) return 0;

  const finalAmount = Number(getorder.orders[0]?.finalAmount ?? 0);
  const advanceAmount = Number(getorder.orders[0]?.creditAdjust ?? 0);

  const totalLedgerDiscount = getorder.orders.reduce(
    (sum, order) => sum + Number(order.ledgerDiscountAmount ?? 0),
    0
  );
  const totalRemainingAmount  = getorder.orders.reduce(
    (sum, order) => sum + Number(order.remainingAmount ?? 0),
    0
  );

   // Calculate balance: finalAmount - receivedBalance - ledgerDiscount - advanceAmount
  let balance = finalAmount - Receivedbalance - totalLedgerDiscount - advanceAmount;

  // If advanceAmount exists and is greater than 0, subtract it from remaining
  // The balance calculation above already handles it
  // const balance = totalRemainingAmount;

  return Math.max(0, balance);
};

  const roundValue = (value?: number): number => {
    if (value == null) return 0;
    const num = Number(value);
    const thirdDecimal = Math.floor(num * 1000) % 10;
    return thirdDecimal >= 5 ? Math.ceil(num * 100) / 100 : Math.floor(num * 100) / 100;
  };

  const cashoutstanging = Number(outstangingamount) - Number(getorder?.orders[0].remainingAmount);

  const Outamount = () => {
    if (showBalance === true) {
      const outstanging = Number(cashoutstanging);
      const remaining = Number(getorder?.orders[0].remainingAmount);
      const amount_in = outstanging + remaining;
      return amount_in;
    } else if (showBalance === false) {
      const remaining = getorder?.orders[0].remainingAmount;
      return remaining;
    }
  };

  const refundAmount = () => {
    const osb = Number(outstangingamount || 0);
    const orderOSB = Number(getorder?.orders[0].remainingAmount || 0);
    const orderCancelAmount = Number(roundValue(Receivedbalance || 0));
    const currentOSB = osb - orderOSB;
    const orderTotalDeduction = currentOSB - orderCancelAmount;
    return orderTotalDeduction;
  };

  const handleclick = (e: React.ChangeEvent<HTMLInputElement>) => {
    let newValue = e.target.value;
    // Allow only numbers + optional decimal
    if (!/^\d*\.?\d*$/.test(newValue)) return;
    const maxAllowedValue = Outamount() ?? 0;
    // Allow only numbers with up to 2 decimal places
    if (!/^\d*\.?\d{0,2}$/.test(newValue)) {
      return;
    }
    // If empty → allow empty (no 0)
    if (newValue === "") {
      setInputValue("");
      setcondition(0);
      return;
    }
    // Prevent leading zero like "01", "02"
    if (newValue.length > 1 && newValue.startsWith("0") && !newValue.startsWith("0.")) {
      newValue = newValue.replace(/^0+/, ""); // remove leading zeros
    }
    const enteredValue = parseFloat(newValue);

    if (!isNaN(enteredValue)) {
      if (enteredValue <= maxAllowedValue) {
        setInputValue(newValue);
        setcondition(enteredValue);
      } else {
        setInputValue(maxAllowedValue.toString());
        setcondition(maxAllowedValue);
      }
    }
  };

  const handleBlur = () => {
    const formatted = Number(condition).toFixed(2);
    setInputValue(formatted);
  };

  const outstandingvalue = () => {
    setcondition(0);
    setInputValue("0");
    setShowBalance(!showBalance);
  };

  const payments = () => {
    if (paylate) {
      setmodel(true);
      setcashpay(false);
    } else if (cashpay) {
      setglowery(true);
      setpaylate(false);
    } else if (paycard) {
      setglowery(true);
      setpaylate(false);
    }
  };

  return {
    filteredCustomerId,
    setFilteredCustomerId,
    printData,
    Remainingpayments,
    Receivedbalance,
    remaining,
    AdvanceAmount,
    discountValue: discount,
    ledgerDiscount,
    roundValue,
    cashoutstanging,
    Outamount,
    refundAmount,
    handleclick,
    handleBlur,
    outstandingvalue,
    payments,
    printHistory,
    setInputValue,
    inputValue,
    condition,
    setcondition,
    model,
    glowery,
    confirm,
    setmodel,
    setglowery,
    setConfirm,
    setPrintHistory,
    setpaylate,
    setcashpay,
    setpaycard,
    paylate,
    cashpay,
    paycard,
  };
};
